import {InputTextArea} from "../../components";
import {useContext, useEffect, useState} from "react";
import {LoadingContext, PageContext, ToastContext, UserContext} from "../../contexts";
import {NotificacaoApi} from "../../apis";
import {useNavigate} from "react-router";
import {FaBell} from "react-icons/fa";

export const NotificacaoEdit = () => {
  const {user} = useContext(UserContext);
  const {pageInfo, setPageInfo} = useContext(PageContext);

  const [texto, setTexto] = useState('');
  const [errorTexto, setErrorTexto] = useState(false);
  const [helperTexto, setHelperTexto] = useState('');
  const {setLoading} = useContext(LoadingContext);

  const navigate = useNavigate();

  const toasts = useContext(ToastContext);
  const AddToast = (item) => {
    let tempArr = [...toasts.toast];
    tempArr.push(item);
    toasts.setToast({toast: tempArr, setToast: toasts.setToast});
  }

  const validarCampos = () => {
    setErrorTexto(false);
    let erro = false;
    if (texto.length === 0) {
      setHelperTexto('O campo não pode estar vazio.');
      setErrorTexto(true);
      erro = true;
    }

    return !erro;
  }

  useEffect(() => {
    setPageInfo(
      {
        ...pageInfo,
        titulo: 'Notificações',
        icone: <FaBell size={30}/>
      }
    );
  }, [])

  const sendNotificacao = async () => {
    setLoading(true);
    if (validarCampos()) {
      try {
        let respostaCreate = await NotificacaoApi.create(user.uuid, texto);
        if (!respostaCreate.error) {
          AddToast({texto: "Enviado!", tipo: "sucesso"});
          setLoading(false);
          navigate('/portalcolaborador/notificacao');
        } else {
          AddToast({texto: respostaCreate.error, tipo: "erro"});
          setLoading(false);
        }
      } catch (err) {
        AddToast({texto: err, tipo: "erro"});
        setLoading(false);
      }
    }
    setLoading(false);
  }

  return (
    <div>
      <h2>Nova Notificação</h2>
      <div className="form-notificacao">
        <div className="notificacao">
          <h4>Informações</h4>
          <InputTextArea
            label="Texto"
            value={texto}
            onChange={(e) => setTexto(e.target.value)}
            error={errorTexto}
            helperText={helperTexto}
          />
          <div className="d-flex justify-end">
            <div className="btn btn-cancelar" onClick={() => navigate(-1)}>
              Cancelar
            </div>
            <div className="btn btn-enviar" onClick={sendNotificacao}>
              Cadastrar
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}